import { createContext, useContext } from 'react';

export type ProductsModelCompareType = {
  selectedModels: string[];
  selectModel: (itemId: string) => void;
  clearSelectedModels: () => void;
  isModelSelected: (itemId: string) => boolean;
};

export const ProductsModelCompareContext = createContext<ProductsModelCompareType>(
  {} as ProductsModelCompareType,
);

export const useProductsModelCompare = (): ProductsModelCompareType => {
  return useContext(ProductsModelCompareContext);
};
